import { render, staticRenderFns } from "./SessionWorkflow.vue?vue&type=template&id=971d8d00"
import script from "./SessionWorkflow.vue?vue&type=script&lang=js"
export * from "./SessionWorkflow.vue?vue&type=script&lang=js"
import style0 from "./SessionWorkflow.vue?vue&type=style&index=0&id=971d8d00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports